import CheckoutLineItem from './CheckoutLineItem';
import logger from 'src/logger';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import orderBy from 'lodash/orderBy';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import withCountry from '../../../../hocs/withCountry';
import withState from 'recompose/withState';
import withPrismicProduct from '../../../../hocs/withPrismicProduct';
import withProductKey from '../../../../hocs/withProductKey';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import { trackEditItem } from '../../../../../analytics/category/cart';
import {
  mergeAddons,
  getFormatImage,
  getTitle,
  getCustomisationString,
  getCustomisations,
  getType,
} from '../../../CartItems/LineItem/helpers';
import { trackGeneralClick } from '../../../../../analytics/category/checkout';

const enhance = compose(
  withRouter,
  withCountry,
  withState('areItemsLoading', 'setAreItemsLoading', true),
  withState('isModalOpen', 'setIsModalOpen', false),
  withProps(props => ({
    productId: props.item.format.product.id,
    productLocale: props.item.customisations.locale,
    lineItemPrefix: props.model.prismicGlobalContentModel.general.lineItemPrefix,
    pathname: props.history.location.pathname,
  })),
  withPrismicProduct(['productInformation', 'cart']),
  withHandlers({
    onEditItem: props => () => trackEditItem(props.item.format.product.id),
    onClick: props => () => {
      props.setIsModalOpen(true);
      trackGeneralClick('open edit book modal', props.pathname);
    },
    onClickClose: props => () => {
      props.setIsModalOpen(false);
      trackGeneralClick('close edit book modal', props.pathname);

    },
  }
  ),
  withProductKey,
  lifecycle({
    componentDidMount() {
      const props = this.props;
      const customisations = omitBy(props.item.customisations, isNil);
      const locale = customisations.locale;
      const countryLocale = props.country.localeCode;
      Promise.all([
        props.getPrismicProduct(props.productId, locale),
        props.getPrismicProduct(props.productId, countryLocale),
      ])
        .then(([product, fallbackProduct]) => {
          props.setAreItemsLoading(false);
        })
        .catch((error) => {
          props.setAreItemsLoading(false);
          logger.error(error);
        });
    },
  }),
  withProps(props => {
    const addons = orderBy(mergeAddons(props), ['type'], ['desc']);

    return {
      onClickLink: {
        editItem: props.onEditItem,
      },
      image: getFormatImage(props).image,
      title: getTitle(props),
      customisationString: getCustomisationString(props),
      itemCustomisation: props.item.customisations,
      type: getType(props),
      addons,
      price: props.item.price,
      savings: props.item.savings,
      hasCustomisations: !!getCustomisations(props),
    };
  }),
);

export default enhance(CheckoutLineItem);



// WEBPACK FOOTER //
// ./src/client/js/view/components/MainCheckout/CheckoutOrderSummary/CheckoutLineItem/index.js